import { reportsApi } from "../store/api/reportsApi";
import { runMutation } from "../store/api/runtime";

export async function createListingReport(payload: Record<string, unknown>): Promise<unknown> {
  return runMutation(reportsApi.endpoints.createListingReport.initiate, payload);
}

export async function createUserReport(payload: Record<string, unknown>): Promise<unknown> {
  return runMutation(reportsApi.endpoints.createUserReport.initiate, payload);
}
